<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="mfa" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>Users In School:</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText" [Disabled]="loading">
				</caass-schoolselector>
			</div>
		</div>

		<div>
			<label>Columns to Display:</label>
			<div class="ColGrid">
				<div class="ColOption">
					<input id="ShowPersonName" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.PersonName" />
					<label for="ShowPersonName">Person Name</label>
				</div>

				<div class="ColOption">
					<input id="ShowOriginalSchool" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.OriginalSchool" />
					<label for="ShowOriginalSchool">Original School</label>
				</div>

				<div class="ColOption">
					<input id="ShowHomeSchool" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.HomeSchool" />
					<label for="ShowHomeSchool">Belongs to School</label>
				</div>

				<div class="ColOption">
					<input id="ShowUserLevelDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.UserLevelDesc" />
					<label for="ShowUserLevelDesc">User Level</label>
				</div>

				<div class="ColOption">
					<input id="ShowEmail" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.Email" />
					<label for="ShowEmail">Email</label>
				</div>

				<div class="ColOption">
					<input id="ShowHighestRoleDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.HighestRoleDesc" />
					<label for="ShowHighestRoleDesc">Highest Role</label>
				</div>

				<div class="ColOption">
					<input id="ShowHighestRoleItemCount" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.HighestRoleItemCount" />
					<label for="ShowHighestRoleItemCount">Highest Role Pages</label>
				</div>

				<div class="ColOption">
					<input id="ShowSBMRoleDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.SBMRoleDesc" />
					<label for="ShowSBMRoleDesc">SBM Role(s)</label>
				</div>

				<div class="ColOption">
					<input id="ShowStatusDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.StatusDesc" />
					<label for="ShowStatusDesc">Active</label>
				</div>

				<div class="ColOption">
					<input id="ShowAccountLocked" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.AccountLocked" />
					<label for="ShowAccountLocked">Locked</label>
				</div>

				<div class="ColOption">
					<input id="ShowLockDetails" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.LockDetails" />
					<label for="ShowLockDetails">Locked/Unlocked Details</label>
				</div>

				<div class="ColOption">
					<input id="ShowLockDT" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.LockDT" />
					<label for="ShowLockDT">Locked/Unlocked Date</label>
				</div>

				<div class="ColOption">
					<input id="ShowLastLoginDT" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.LastLoginDT" />
					<label for="ShowLastLoginDT">Last Login Date</label>
				</div>

				<div class="ColOption">
					<input id="Showc_date" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.c_date" />
					<label for="Showc_date">Last Updated</label>
				</div>

				<div class="ColOption">
					<input id="ShowMFAEnabledDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.MFAEnabledDesc" />
					<label for="ShowMFAEnabledDesc">MFA Enabled</label>
				</div>

				<div class="ColOption">
					<input id="ShowMFARegisteredDesc" class="form-control CHK" type="checkbox" [(ngModel)]="ShowColumns.MFARegisteredDesc" />
					<label for="ShowMFARegisteredDesc">MFA Registered</label>
				</div>

				<div class="ButtonColOption">
					<button class="btn btn-primary" style="margin: 0px" (click)="onResetColOption()">Reset</button>
				</div>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<!--Refresh Button-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button *ngIf="DisableAddUser == false" [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddUser()">Add User</button>
		<button *ngIf="DisableEditUser == false" [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditUser()">Edit User</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleUser()">
			{{ ToggleText }}
		</button>
		<button *ngIf="DeleteUserAllowed() == true" [disabled]="loading" class="btn btn-danger" style="margin-left: 5px" (click)="onDeleteUser()">
			Delete User
		</button>
		<button [disabled]="loading" class="btn btn-warning" style="margin-left: 5px" (click)="onResetPassword()">Reset Password</button>
		<button [disabled]="loading" class="btn btn-warning" style="margin-left: 5px" (click)="onToggleMFA()">Toggle MFA</button>
		<button [disabled]="loading" class="btn btn-warning" style="margin-left: 5px" (click)="onToggleAllMFA()">Update All MFA</button>
		<!-- <button *ngIf="IsSU() == true" [disabled]="loading" class="btn btn-primary" style="margin-left:5px;" (click)="onDebugUser()">Debug User (SU Only)</button> -->
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstUsers"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedUser"
		dataKey="UserID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--User Name-->
				<th>
					<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Person Name-->
				<th *ngIf="ShowColumns.PersonName == true">
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--OriginalSchoolName-->
				<th *ngIf="ShowColumns.OriginalSchool == true">
					<p-columnFilter field="OriginalSchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterOriginalSchoolName
								[ngModel]="value"
								[options]="lstOriginalSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HomeSchoolDesc-->
				<th *ngIf="ShowColumns.HomeSchool == true">
					<p-columnFilter field="HomeSchoolDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHomeSchoolDesc
								[ngModel]="value"
								[options]="lstHomeSchoolDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--User Level-->
				<th *ngIf="ShowColumns.UserLevelDesc == true">
					<p-columnFilter field="UserLevelDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUserLevelDesc
								[ngModel]="value"
								[options]="lstUserLevelDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Defined By Desc-->
				<!-- <th>
                    <p-columnFilter field="PersonDefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterPersonDefinedByDesc [ngModel]="value" [options]="lstPersonDefinedByDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
                </th> -->

				<!--Email-->
				<th *ngIf="ShowColumns.Email == true">
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--HighestRoleDesc-->
				<th *ngIf="ShowColumns.HighestRoleDesc == true">
					<p-columnFilter field="HighestRoleDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHighestRoleDesc
								[ngModel]="value"
								[options]="lstHighestRoleDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HighestRoleItemCount-->
				<th *ngIf="ShowColumns.HighestRoleItemCount == true"></th>

				<!--ShowSBMRoleDesc-->
				<th *ngIf="ShowColumns.SBMRoleDesc == true">
					<p-columnFilter type="text" field="SBMRoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Status-->
				<th *ngIf="ShowColumns.StatusDesc == true">
					<p-columnFilter field="StatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStatusDesc
								[ngModel]="value"
								[options]="lstStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Account Locked-->
				<th *ngIf="ShowColumns.AccountLocked == true">
					<p-columnFilter field="AccountLocked" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAccountLocked
								[ngModel]="value"
								[options]="lstAccountLocked"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LockDetails-->
				<th *ngIf="ShowColumns.LockDetails == true">
					<p-columnFilter type="text" field="LockDetails" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LockDT-->
				<th *ngIf="ShowColumns.LockDT == true"></th>

				<!--LastLoginDT-->
				<th *ngIf="ShowColumns.LastLoginDT == true"></th>

				<!--c_date-->
				<th *ngIf="ShowColumns.c_date == true"></th>

				<!--MFAEnabledDesc-->
				<th *ngIf="ShowColumns.MFAEnabledDesc == true" class="MFAEnableWidth">
					<p-columnFilter field="MFAEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterMFAEnabledDesc
								[ngModel]="value"
								[options]="lstMFAEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--MFARegisteredDesc, Used to Reset MFA-->
				<th *ngIf="ShowColumns.MFARegisteredDesc == true">
					<p-columnFilter field="MFARegisteredDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterMFARegisteredDesc
								[ngModel]="value"
								[options]="lstMFARegisteredDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="UserName">User Name<p-sortIcon field="UserName"></p-sortIcon></th>
				<th *ngIf="ShowColumns.PersonName == true" pSortableColumn="PersonName">Person Name<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th *ngIf="ShowColumns.OriginalSchool == true" pSortableColumn="OriginalSchoolName">
					Original School<p-sortIcon field="OriginalSchoolName"></p-sortIcon>
				</th>
				<th *ngIf="ShowColumns.HomeSchool == true" pSortableColumn="HomeSchoolDesc">
					Belongs to School<p-sortIcon field="HomeSchoolDesc"></p-sortIcon>
				</th>
				<th *ngIf="ShowColumns.UserLevelDesc == true" pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
				<th *ngIf="ShowColumns.Email == true" pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<!-- <th pSortableColumn="PersonDefinedByDesc">Person Defined By<p-sortIcon field="PersonDefinedByDesc"></p-sortIcon></th> -->
				<th *ngIf="ShowColumns.HighestRoleDesc == true" pSortableColumn="HighestRoleDesc">
					Highest Role at school<p-sortIcon field="HighestRoleDesc"></p-sortIcon>
				</th>
				<th *ngIf="ShowColumns.HighestRoleItemCount == true" pSortableColumn="HighestRoleItemCount">
					Highest Role Page Count<p-sortIcon field="HighestRoleItemCount"></p-sortIcon>
				</th>
				<th *ngIf="ShowColumns.SBMRoleDesc == true" pSortableColumn="SBMRoleDesc">SBM Role(s)<p-sortIcon field="SBMRoleDesc"></p-sortIcon></th>

				<th *ngIf="ShowColumns.StatusDesc == true" pSortableColumn="StatusDesc">Status<p-sortIcon field="StatusDesc"></p-sortIcon></th>
				<th *ngIf="ShowColumns.AccountLocked == true" pSortableColumn="AccountLocked">Account Lock<p-sortIcon field="AccountLocked"></p-sortIcon></th>
				<th *ngIf="ShowColumns.LockDetails == true" pSortableColumn="LockDetails">Lock Details<p-sortIcon field="LockDetails"></p-sortIcon></th>
				<th *ngIf="ShowColumns.LockDT == true" pSortableColumn="LockDT">Locked/Unlocked Date<p-sortIcon field="LockDT"></p-sortIcon></th>
				<th *ngIf="ShowColumns.LastLoginDT == true" pSortableColumn="LastLoginDT">Last Logged In<p-sortIcon field="LastLoginDT"></p-sortIcon></th>
				<th *ngIf="ShowColumns.c_date == true" pSortableColumn="c_date">Last Modified<p-sortIcon field="c_date"></p-sortIcon></th>
				<th *ngIf="ShowColumns.MFAEnabledDesc == true" pSortableColumn="MFAEnabledDesc" class="MFAEnableWidth">
					MFA Enabled<p-sortIcon field="MFAEnabledDesc"></p-sortIcon>
				</th>
				<th *ngIf="ShowColumns.MFARegisteredDesc == true" pSortableColumn="MFARegisteredDesc">
					Registered For MFA<p-sortIcon field="MFARegisteredDesc"></p-sortIcon>
				</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-user>
			<tr [pSelectableRow]="user" (dblclick)="onRowDblClick(user)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.UserName }}
				</td>

				<td *ngIf="ShowColumns.PersonName == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.PersonName }}
				</td>

				<td
					*ngIf="ShowColumns.OriginalSchool == true"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="user.HomeSchool == 1 ? 'Black' : 'Red'"
				>
					{{ user.OriginalSchoolName }}
				</td>

				<td
					*ngIf="ShowColumns.HomeSchool == true"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="user.HomeSchool == 1 ? 'Black' : 'Red'"
				>
					{{ user.HomeSchoolDesc }}
				</td>

				<td *ngIf="ShowColumns.UserLevelDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.UserLevelDesc }}
				</td>

				<td *ngIf="ShowColumns.Email == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.Email }}
				</td>

				<td *ngIf="ShowColumns.HighestRoleDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.HighestRoleDesc }}
				</td>

				<td *ngIf="ShowColumns.HighestRoleItemCount == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.HighestRoleItemCount }}
				</td>

				<td *ngIf="ShowColumns.SBMRoleDesc == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.SBMRoleDesc }}
				</td>

				<td
					*ngIf="ShowColumns.StatusDesc == true"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="user.AccountActive == 1 ? 'Black' : 'Red'"
				>
					{{ user.StatusDesc }}
				</td>

				<td *ngIf="ShowColumns.AccountLocked == true">
					<button
						[ngClass]="{
							btn: true,
							LockedButton: user['AccountLocked'] == 'Locked',
							UnlockedButton: user['AccountLocked'] == 'Unlocked'
						}"
						(click)="UpdateLock(user['UserID'], user['AccountLocked'])"
					>
						<i *ngIf="user['AccountLocked'] == 'Locked'" class="fa fa-lock LockedImage"></i>
						<i *ngIf="user['AccountLocked'] == 'Unlocked'" class="fa fa-unlock UnlockedImage"></i>
					</button>
				</td>

				<td *ngIf="ShowColumns.LockDetails == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.LockDetails }}
				</td>

				<td *ngIf="ShowColumns.LockDT == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.LockDTDesc }}
				</td>

				<td *ngIf="ShowColumns.LastLoginDT == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.LastLoginDTDesc }}
				</td>

				<td *ngIf="ShowColumns.c_date == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ user.c_dateDesc }}
				</td>

				<td *ngIf="ShowColumns.MFAEnabledDesc == true" class="MFAEnableWidth">
					<div style="display: grid">
						<input
							type="checkbox"
							class="CHK"
							style="margin-left: auto; margin-right: auto"
							[ngModel]="user.MFAEnabled == true || user.MFAEnabledOverride == true"
							[disabled]="user.MFAEnabledOverride == true"
							(click)="onToggleMFAUser(user)"
						/>
						<label
							*ngIf="user.MFAEnabledOverride"
							style="font-weight: bold; text-overflow: ellipsis; word-break: break-word; color: red; margin-top: 10px; text-align: center"
							>{{ user.MFAEnabledDesc }}</label
						>
					</div>
				</td>

				<td *ngIf="ShowColumns.MFARegisteredDesc == true && user.MFARegistered">
					<button class="btn btn-danger" (click)="onResetMFARegistration(user)">
						<i class="fa fa-undo" aria-hidden="true"></i>
					</button>
				</td>
				<td
					*ngIf="ShowColumns.MFARegisteredDesc == true && !user.MFARegistered"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word; color: red"
				>
					<label>Not Registered</label>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
